import { AnalyticsEvent } from "@adsk/acc-issues-core/utils/analytics/analyticsTypes";

export class IssueEditSelectEvent implements AnalyticsEvent {
  name = "issue.edit.select";
  parameters = {};
}
